<template>
    <div>
        <div class="content-heading">
            <i class="ic-head-icon">
                <img src="@/assets/images/sidebar/reports.svg" alt="Master Data">
            </i>
            <h4 class="head-title">{{ title }}</h4>
            <i class="ic-tooltip" id="help"></i>
            <b-popover target="help"
                triggers="hover"
                content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.">
            </b-popover>
            <app-tab :tabs="tabs"></app-tab>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
import AppTabs from "@/components/common/AppTabs.vue";
const tabs = [
    {
        name: "Outlet Master",
        href: "/reports/outlet-master",
        access: "reports:topup.outlet:topup-reports"
    },
    {
        name: "Asset Master",
        href: "/reports/asset-master",
        access: "reports:topup.asset:topup-reports"
    },
    {
        name: "SRP Database",
        href: "/reports/srp-database",
        access: "reports:topup.srp:topup-reports"
    },
    {
        name: "Channel Matrix",
        href: "/reports/channel-matrix",
        access: "reports:topup.matrix:topup-reports"
    },
    {
        name: "Transaction Upload",
        href: "/reports/transaction-upload",
        access: "reports:topup.transaction-upload"
    }
];
export default {
    name: "Reports",
    data() {
        return {
            tabs: tabs,
            title: "Master Data"
        }
    },
    components: {
        "app-tab": AppTabs
    }
};
</script>
